module.exports = __webpack_public_path__ + "static/media/payment-success.5ce810ea.svg";